import { render, staticRenderFns } from "./twice-alarm-set.vue?vue&type=template&id=5ae0d368&scoped=true"
import script from "./twice-alarm-set.vue?vue&type=script&lang=js"
export * from "./twice-alarm-set.vue?vue&type=script&lang=js"
import style0 from "./twice-alarm-set.vue?vue&type=style&index=0&id=5ae0d368&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae0d368",
  null
  
)

export default component.exports